export enum TagCategoryEnum {
  RUN = "RUN",
  PASS = "PASS",
  DEFENSE = "DEFENSE",
  SPECIAL_TEAMS = "SPECIAL TEAMS",
}
